import { createEvent, createStore } from 'effector'

export const actions = {
  setCodeVerifier: createEvent<string>('setCodeVerifier'),
  resetCodeVerifier: createEvent<void>('resetCodeVerifier'),
  setTokens: createEvent<OauthCredentials>('setTokens'),
  resetTokens: createEvent<void>('resetTokens'),
  acceptCgus: createEvent<void>('acceptCgus'),
  logout: createEvent<void>('logout'),
  reset: createEvent('reset'),
}

const initialState: AuthState = {
  OAuth: undefined,
  code_verifier: undefined,
  has_accept_cgu: false,
}

export const store = createStore<AuthState>(initialState)
  .on(actions.setCodeVerifier, (s, code_verifier) => ({ ...s, code_verifier }))
  .on(actions.resetCodeVerifier, (s) => ({ ...s, code_verifier: undefined }))
  .on(actions.setTokens, (s, OAuth) => ({ ...s, OAuth, code_verifier: undefined }))
  .on(actions.resetTokens, () => ({ ...initialState }))
  .on(actions.acceptCgus, (s) => ({ ...s, has_accept_cgu: true }))
  .on(actions.logout, () => ({ ...initialState }))
  .on(actions.reset, () => ({ ...initialState }))
